export default {
    namespaced: true,

    state: {
        // iframe 页面index集合
        iframeIndexStr: '',
        // 上报index集合
        reportingStr: ''
    },

    getters: {
        iframeIndexStr: state => state.iframeIndexStr,
        reportingStr: state => state.reportingStr
    },

    mutations: {
        setIframeIndexStr: function setIframeIndexStr(state, {type = '', index = ''}) {
            if (type === 'add') {
                state.iframeIndexStr += '| ' + index;
            }
            else if (type === 'delete') {
                state.iframeIndexStr = index;
            }
        },
        setReportingStr: function setReportingStr(state, {type = '', index = ''}) {
            if (type === 'add') {
                state.reportingStr += '| ' + index;
            }
            else if (type === 'delete') {
                state.reportingStr = index;
            }
        }
    },

    actions: {
    }
};